import api from './api';

const tgApi = {
  // Members
  getMembers: (params) => api.get('/api/tg/members', { params }),
  getMemberCount: () => api.get('/api/tg/members/count'),
  getMember: (id) => api.get(`/api/tg/members/${id}`),
  createMember: (data) => api.post('/api/tg/members', data),
  updateMember: (id, data) => api.patch(`/api/tg/members/${id}`, data),
  deleteMember: (id) => api.delete(`/api/tg/members/${id}`),

  // Bots (멀티봇)
  getBots: () => api.get('/api/tg/bots'),
  getBotOptions: () => api.get('/api/tg/bots/options'),
  getBot: (id, params) => api.get(`/api/tg/bots/${id}`, { params }),
  createBot: (data) => api.post('/api/tg/bots', data),
  updateBot: (id, data) => api.patch(`/api/tg/bots/${id}`, data),
  deleteBot: (id) => api.delete(`/api/tg/bots/${id}`),
  getBotStatus: (id) => api.get(`/api/tg/bots/${id}/status`),
  testBot: (id) => api.post(`/api/tg/bots/${id}/test`),
  getBotLanding: (slug) => api.get(`/api/tg/bots/landing/${slug}`),
  getLandingByHost: (host) => api.get('/api/tg/bots/landing/by-host', { params: { host } }),
  getBotDomains: (id) => api.get(`/api/tg/bots/${id}/domains`),
  addBotDomain: (id, domain) => api.post(`/api/tg/bots/${id}/domains`, { domain }),
  deleteBotDomain: (domainId) => api.delete(`/api/tg/bots/domains/${domainId}`),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/api/tg/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // 분석 (전환 통계)
  getAnalyticsSummary: (days) => api.get('/api/tg/analytics/summary', { params: { days } }),
  getAnalyticsLabels: (params) => api.get('/api/tg/analytics/labels', { params }),
  getAnalyticsTimeseries: (params) => api.get('/api/tg/analytics/timeseries', { params }),
  getAnalyticsHeatmap: (params) => api.get('/api/tg/analytics/heatmap', { params }),

  // Contacts (연락처/문자 데이터)
  getContacts: (params) => api.get('/api/tg/contacts', { params }),
  getContactStats: () => api.get('/api/tg/contacts/stats'),
  createContact: (data) => api.post('/api/tg/contacts', data),
  updateContact: (id, data) => api.patch(`/api/tg/contacts/${id}`, data),
  deleteContact: (id) => api.delete(`/api/tg/contacts/${id}`),
  bulkUploadContacts: (data) => api.post('/api/tg/contacts/bulk', data),
  markInvalidContacts: (data) => api.post('/api/tg/contacts/mark-invalid', data),
  bulkStatusContacts: (data) => api.post('/api/tg/contacts/bulk-status', data),
  sendContacts: (data) => api.post('/api/tg/contacts/send', data),

  // Q&A
  getQAItems: (params) => api.get('/api/tg/qa', { params }),
  createQAItem: (data) => api.post('/api/tg/qa', data),
  updateQAItem: (id, data) => api.patch(`/api/tg/qa/${id}`, data),
  deleteQAItem: (id) => api.delete(`/api/tg/qa/${id}`),
  reorderQA: (data) => api.post('/api/tg/qa/reorder', data),
  testQA: (data) => api.post('/api/tg/qa/test', data),
  getUnmatchedQA: (params) => api.get('/api/tg/qa/unmatched', { params }),
  bulkQA: (items) => api.post('/api/tg/qa/bulk', items),

  // Send / Messaging
  sendToSelected: (data) => api.post('/api/tg/send', data),
  sendToAll: (data) => api.post('/api/tg/send/all', data),
  getSendLogs: (params) => api.get('/api/tg/send/logs', { params }),
  getSendStats: () => api.get('/api/tg/send/stats'),
  checkEmailProviders: () => api.get('/api/tg/send/email/providers'),
  testEmail: (data) => api.post('/api/tg/send/email/test', data),
  getSmsStatus: () => api.get('/api/tg/send/sms/status'),
  sendSms: (data) => api.post('/api/tg/send/sms', data),
  sendSmsAll: (data) => api.post('/api/tg/send/sms/all', data),
  sendDirect: (data) => api.post('/api/tg/send/direct', data),
  sendSmsDirect: (data) => api.post('/api/tg/send/sms/direct', data),

  // Templates
  getTemplates: (params) => api.get('/api/tg/templates', { params }),
  createTemplate: (data) => api.post('/api/tg/templates', data),
  updateTemplate: (id, data) => api.patch(`/api/tg/templates/${id}`, data),
  deleteTemplate: (id) => api.delete(`/api/tg/templates/${id}`),
  reorderTemplates: (data) => api.post('/api/tg/templates/reorder', data),

  // Settings
  getSettings: () => api.get('/api/tg/settings'),
  getPublicSettings: () => api.get('/api/tg/settings/public'),
  updateSettings: (data) => api.put('/api/tg/settings', data),
  getMessagingStatus: () => api.get('/api/tg/settings/messaging/status'),
  restartBot: () => api.post('/api/tg/bot/restart'),

  // Security
  getSecurityLogs: (params) => api.get('/api/tg/security/logs', { params }),
  getSecurityStats: () => api.get('/api/tg/security/stats'),
  getSmsServiceStatus: () => api.get('/api/tg/security/sms/status'),
  // 다오문자 (DAO SMS) - 라우트 경로는 기존 유지
  updateIsms888Config: (data) => api.post('/api/tg/security/sms/isms888', data),
  testIsms888: () => api.post('/api/tg/security/sms/isms888/test'),
  getIsms888Info: () => api.get('/api/tg/security/sms/isms888/info'),

  // Consultations
  getConsultations: (params) => api.get('/api/tg/consultations', { params }),
  getConsultationStats: () => api.get('/api/tg/consultations/stats'),
  getRecentConsultations: () => api.get('/api/tg/consultations/recent'),
  updateConsultation: (id, data) => api.patch(`/api/tg/consultations/${id}`, data),
  replyConsultation: (id, data) => api.post(`/api/tg/consultations/${id}/reply`, data),
  deleteConsultation: (id) => api.delete(`/api/tg/consultations/${id}`),

  // Auto-reply logs (자동응답 내역)
  getAutoReplies: (params) => api.get('/api/tg/auto-replies', { params }),
  getAutoReplyStats: (params) => api.get('/api/tg/auto-replies/stats', { params }),

  // Health
  getHealth: () => api.get('/api/tg/health'),
};

export default tgApi;
